import { useEffect, useState } from 'react';

import { formatDate } from 'coreOld/utils';

import DateRangeView from './DateRangeView';

interface IProps {
  onChange;
  name: string;
  filter: Record<string, any>;
  value?: string;
}

const DateRange = ({ onChange, value }: IProps) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const value = `${formatDate(startDate)}|${formatDate(endDate)}`;

    if (startDate && endDate) {
      onChange(value);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (!value) {
      setStartDate(null);
      setEndDate(null);

      return;
    }
  }, [value]);

  return (
    <DateRangeView
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      value={value}
    />
  );
};

export default DateRange;
